module.exports = __webpack_public_path__ + "img/5_1.7fff49b1.png";